import * as Sentry from '@sentry/vue';
import { useRouter } from 'vue-router';

import { defineAppPlugin } from '@/main';

export default defineAppPlugin(context => {
  const DSN = import.meta.env.VITE_APP_SENTRY_DSN;
  const router = useRouter();

  Sentry.init({
    app: context.app,
    dsn: DSN,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    environment: import.meta.env.VITE_APP_MODE ?? import.meta.env.MODE,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
  });
});
